module.exports = __webpack_public_path__ + "static/instock-preview-757edec12cdc7ada9bd375e41ad83551.png";